(() => {
  const root = window.Shopify?.routes?.root || '/';
  const key = 'mas-recommendations-v1';
  const context = JSON.parse(document.getElementById('MasRecommendationContext')?.textContent || '{}');
  let history = { views: [], searches: [], at: Date.now() };
  let permitted = false;
  let optedOut = false;
  try { optedOut = sessionStorage.getItem('mas-recommendations-off') === '1'; } catch (_) {}
  const cache = new Map();
  const safeRead = () => {
    try {
      const saved = JSON.parse(sessionStorage.getItem(key) || 'null');
      if (saved && Date.now() - saved.at < 86400000) {
        history.views = (saved.views || []).filter(p => /^[a-z0-9-]+$/.test(p.handle)).slice(0, 30);
        history.searches = (saved.searches || []).filter(q => typeof q === 'string').slice(0, 3);
      }
    } catch (_) {}
  };
  const save = () => {
    if (!permitted) return;
    history.at = Date.now();
    try { sessionStorage.setItem(key, JSON.stringify(history)); } catch (_) {}
  };
  const rememberProduct = (p) => {
    if (!permitted || !p?.handle) return;
    history.views = [p, ...history.views.filter(v => v.handle !== p.handle)].slice(0, 30);
    save();
  };
  const rememberSearch = (value) => {
    if (!permitted) return;
    const q = String(value || '').trim().slice(0, 100);
    if (q.length < 2) return;
    history.searches = [q, ...history.searches.filter(v => v !== q)].slice(0, 3);
    save();
  };
  const notify = () => document.dispatchEvent(new Event('mas:interests'));
  const consent = () => {
    const privacy = window.Shopify?.customerPrivacy;
    const next = Boolean(privacy?.preferencesProcessingAllowed?.()) && !optedOut;
    if (next && !permitted) { safeRead(); permitted = true; rememberProduct(context.product); rememberSearch(context.search); }
    else if (!next) {
      permitted = false; history = { views: [], searches: [], at: Date.now() }; cache.clear();
      try { sessionStorage.removeItem(key); } catch (_) {}
    }
    notify();
  };
  document.addEventListener('visitorConsentCollected', consent);
  if (window.Shopify?.customerPrivacy) consent();
  else window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.1' }], error => { if (!error) consent(); });
  document.addEventListener('submit', event => {
    const input = event.target.querySelector?.('input[name="q"]');
    if (input) { rememberSearch(input.value); notify(); }
  }, true);
  document.addEventListener('click', event => {
    const anchor = event.target.closest('a[href]');
    if (!anchor || !permitted) return;
    let url;
    try { url = new URL(anchor.href, location.href); } catch (_) { return; }
    if (url.origin !== location.origin) return;
    const match = url.pathname.match(/\/products\/([a-z0-9-]+)/);
    if (match) {
      const searchInput = anchor.closest('predictive-search')?.querySelector('input[name="q"]');
      if (searchInput) rememberSearch(searchInput.value);
      rememberProduct({ handle: match[1] });
      notify();
    } else if (url.pathname.endsWith('/search')) { rememberSearch(url.searchParams.get('q')); notify(); }
  }, true);
  const json = async (path) => {
    if (!cache.has(path)) {
      if (cache.size > 40) cache.delete(cache.keys().next().value);
      cache.set(path, fetch(root + path, { credentials: 'same-origin' }).then(r => {
        if (!r.ok) throw new Error('Unavailable');
        return r.json();
      }).catch(error => { cache.delete(path); throw error; }));
    }
    return cache.get(path);
  };
  const product = handle => json(`products/${encodeURIComponent(handle)}.js`);
  const related = id => json(`recommendations/products.json?product_id=${id}&limit=10&intent=related`).then(r => r.products || []);
  const tokens = value => String(value || '').toLowerCase().split(/[^\p{L}\p{N}]+/u).filter(v => v.length > 2);
  const select = (entries, cart, views, searches) => {
    const excluded = new Set([...cart, ...views].map(p => p.handle));
    const interests = new Set(tokens([...cart, ...views.slice(0, 3)].map(p => [p.title, p.vendor, p.type, ...(p.tags || [])].join(' ')).join(' ')));
    const terms = new Set(tokens(searches.join(' ')));
    const candidates = new Map();
    entries.forEach(({ p, weight }) => {
      if (!p?.available || excluded.has(p.handle) || !p.variants?.some(v => v.available && v.requires_shipping !== false)) return;
      const text = new Set(tokens([p.title, p.vendor, p.type, ...(p.tags || [])].join(' ')));
      const score = weight + [...text].filter(t => interests.has(t)).length * 2 + [...text].filter(t => terms.has(t)).length * 8;
      const discounted = p.variants.some(v => v.available && v.requires_shipping !== false && Number(v.compare_at_price) > Number(v.price));
      const previous = candidates.get(p.handle);
      if (!previous || previous.score < score) candidates.set(p.handle, { p, score, discounted });
    });
    return [...candidates.values()].sort((a, b) => Number(b.discounted) - Number(a.discounted) || b.score - a.score).slice(0, 5).map(v => v.p);
  };
  class Recommendations extends HTMLElement {
    connectedCallback() {
      this.generation = 0;
      this.cart = JSON.parse(this.querySelector('[data-cart-seeds]').textContent);
      this.list = this.querySelector('.mas-rec-list');
      this.media = matchMedia('(min-width: 990px)');
      this.place = () => {
        const inner = this.closest('.drawer__inner');
        const main = inner?.querySelector('.mas-cart-main');
        if (!main) return;
        if (this.media.matches) { if (this.parentElement !== inner) inner.insertBefore(this, main); }
        else if (this.parentElement !== main) main.querySelector('cart-drawer-items')?.before(this);
      };
      this.update = () => {
        const button = this.querySelector('[data-rec-consent]');
        button.disabled = !window.Shopify?.customerPrivacy?.setTrackingConsent;
        button.textContent = permitted ? button.dataset.disable : button.dataset.enable;
        button.setAttribute('aria-pressed', String(permitted));
        if (!this.closest('cart-drawer') || this.closest('cart-drawer').classList.contains('active')) this.load();
      };
      this.observer = new MutationObserver(this.update);
      if (this.closest('cart-drawer')) this.observer.observe(this.closest('cart-drawer'), { attributes: true, attributeFilter: ['class'] });
      this.media.addEventListener('change', this.place);
      document.addEventListener('mas:interests', this.update);
      this.addEventListener('click', this.onClick = event => {
        const button = event.target.closest('[data-rec-add]');
        if (button) this.add(button);
        const preference = event.target.closest('[data-rec-consent]');
        if (preference && !preference.disabled) {
          if (permitted) {
            optedOut = true;
            try { sessionStorage.setItem('mas-recommendations-off', '1'); } catch (_) {}
            consent();
          } else {
            optedOut = false;
            try { sessionStorage.removeItem('mas-recommendations-off'); } catch (_) {}
            preference.disabled = true;
            window.Shopify.customerPrivacy.setTrackingConsent({ preferences: true }, consent);
          }
        }
      });
      queueMicrotask(() => { this.place(); this.update(); });
    }
    disconnectedCallback() {
      this.generation++;
      this.observer?.disconnect();
      this.media?.removeEventListener('change', this.place);
      document.removeEventListener('mas:interests', this.update);
      this.removeEventListener('click', this.onClick);
    }
    async load() {
      const generation = ++this.generation;
      const views = permitted ? [...history.views] : [];
      const searches = permitted ? [...history.searches] : [];
      const entries = [];
      const tasks = this.cart.slice(-2).map(async p => { (await related(p.id)).forEach(p => entries.push({ p, weight: 30 })); });
      views.slice(0, 2).forEach(v => tasks.push((async () => {
        const seed = v.id ? v : await product(v.handle);
        (await related(seed.id)).forEach(p => entries.push({ p, weight: 40 }));
      })()));
      searches.slice(0, 2).forEach((q, i) => tasks.push((async () => {
        const r = await json(`search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=hide`);
        const found = r.resources?.results?.products || [];
        await Promise.allSettled(found.slice(0, 3).map(async p => entries.push({ p: { ...await product(p.handle), url: p.url }, weight: 50 - i * 5 })));
        if (found[0]) (await related(found[0].id)).forEach(p => entries.push({ p, weight: 35 - i * 5 }));
      })()));
      await Promise.allSettled(tasks);
      if (generation !== this.generation || !this.isConnected) return;
      const result = select(entries, this.cart, views, searches);
      this.list.style.setProperty('--mas-rec-columns', String(Math.min(5, result.length) || 1));
      this.list.replaceChildren(...result.map(p => this.card(p)));
      this.hidden = result.length === 0;
    }
    card(p) {
      const li = document.createElement('li'); li.className = 'mas-rec-card';
      const link = document.createElement('a'); link.className = 'mas-rec-link';
      const url = new URL(p.url || `${root}products/${p.handle}`, location.origin);
      if (url.origin !== location.origin) return li;
      if (!url.pathname.startsWith(root)) url.pathname = root + url.pathname.replace(/^\//, '');
      link.href = url.pathname + url.search;
      const image = document.createElement('img'); image.className = 'mas-rec-image'; image.alt = ''; image.loading = 'lazy'; image.width = 180; image.height = 120;
      const source = p.featured_image?.url || p.featured_image || p.images?.[0];
      if (source) { const src = new URL(source, location.origin); src.searchParams.set('width', '240'); image.src = src.href; link.append(image); }
      if (p.vendor) { const vendor = document.createElement('span'); vendor.className = 'mas-rec-vendor'; vendor.textContent = p.vendor; link.append(vendor); }
      const title = document.createElement('span'); title.className = 'mas-rec-title'; title.textContent = p.title; link.append(title); li.append(link);
      const price = document.createElement('p'); price.className = 'mas-rec-price';
      const amounts = p.variants.filter(v => v.available).map(v => Number(v.price));
      const language = document.documentElement.lang || 'en';
      const locale = language.startsWith('de') ? 'de-CH' : language.startsWith('en') ? 'en-CH' : language;
      const money = new Intl.NumberFormat(locale, { style: 'currency', currency: this.dataset.currency || 'CHF' });
      price.textContent = (Math.min(...amounts) !== Math.max(...amounts) ? this.dataset.from + ' ' : '') + money.format(Number(p.price) / 100); li.append(price);
      const variant = p.variants.find(v => v.available);
      const action = document.createElement(p.variants.length === 1 && !p.selling_plan_groups?.length ? 'button' : 'a'); action.className = 'mas-rec-action';
      if (action.tagName === 'BUTTON') { action.type = 'button'; action.dataset.recAdd = variant.id; action.textContent = this.dataset.add; action.dataset.handle = p.handle; }
      else { action.href = link.href; action.textContent = this.dataset.choose; }
      li.append(action); return li;
    }
    async add(button) {
      if (button.disabled) return;
      button.disabled = true;
      const status = this.querySelector('.mas-rec-status'); status.textContent = '';
      try {
        const drawer = this.closest('cart-drawer');
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(button.dataset.recAdd), quantity: 1 }], sections: drawer ? drawer.getSectionsToRender().map(s => s.id) : ['cart-icon-bubble'], sections_url: location.pathname })
        });
        const data = await response.json();
        if (!response.ok || data.status) throw new Error('Add failed');
        if (!drawer) { location.reload(); return; }
        drawer.renderContents(data, true);
        drawer.classList.remove('is-empty');
        const heading = drawer.querySelector('.drawer__heading');
        heading?.setAttribute('tabindex', '-1');
        if (typeof trapFocus === 'function') trapFocus(drawer.querySelector('.drawer__inner'), heading);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-drawer-items', cartData: data });
      } catch (_) { status.textContent = this.dataset.error; button.disabled = false; }
    }
  }
  customElements.define('mas-cart-recommendations', Recommendations);
})();

